import { render } from "./pda.vue?vue&type=template&id=21a8a544&scoped=true"
import script from "./pda.vue?vue&type=script&lang=js"
export * from "./pda.vue?vue&type=script&lang=js"

import "./pda.vue?vue&type=style&index=0&id=21a8a544&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a8a544"]])

export default __exports__